/**
 * @file 検索条件クリア
 */
'use strict'

import Common from '../../Utils/Common'

/**
 * @classname ClearSearchCondition
 * @classdesc 検索条件クリア
 */
export default class ClearSearchCondition {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ClearSearchCondition.constructor')
		this._$e = $e

		$e.on('click', () => this.onClick())
	}

	/**
	 * clickのコールバック
	 *
	 * @memberof ClearSearchCondition
	 * @return {undefined}
	 */
	onClick() {
		console.log('ClearSearchCondition.onClick')

		let $tagetBtn
		if(this._$e.hasClass('btn--clear-all')){
			$tagetBtn = this._$e.closest('body.detail-search').find('.input-checkbox-btn .input-checkbox-btn__input')
			this._$e.closest('body.detail-search').find('.freeword .input-search').val('')
			console.log('all clear::' + $tagetBtn)
		}else{
			$tagetBtn = this._$e.closest('dl').find('.input-checkbox-btn .input-checkbox-btn__input')
		}

		$tagetBtn.each((idx, e) => {
			const $e = $(e);
			$e.removeClass('active')
			$e.prop('checked', false)

			const modalId = $e.attr('data-target')
			const modal = $(`${modalId}`)
			if(modal[0]) {
				const modalBtn = modal.find('.input-checkbox-btn .input-checkbox-btn__input')
				modalBtn.each((idx, e) => {
					const $e = $(e);
					$e.prop('checked', false)
				});
			}
		});
	}
}
